import type { BoxProps } from '@packages/shared';
import { Box } from '@packages/shared';

export const SlotBox = ({ sx, ...props }: BoxProps) => (
  <Box
    sx={{ p: [1.5, 1.5, 3], backgroundColor: 'grey.light', paddingBottom: [3, 3, 5], ...sx }}
    {...props}
  />
);
